// layout
import Layout_Main from "@/views/layout/index.vue";
import Layout_Full from "@/views/layout/layout.full.vue";
// router
import assets from "./router.assets";
import account from "./router.account";
import inquiry from "./router.inquiry";
import about from "./router.about";

export default [
  {
    path: "/",
    redirect: "/index"
  },
  {
    path: "",
    name: "main",
    component: Layout_Main,
    children: [
      // 首页
      {
        path: "/index",
        name: "index",
        component: () => import("@/views/index/index.vue")
      },
      // 资产
      ...assets,
      // 询价
      ...inquiry,
      // 关于我们
      ...about
    ]
  },
  {
    path: "",
    name: "fullMain",
    component: Layout_Full,
    children: [
      // 资产
      ...account
    ]
  }
];
